import CircleIcon from "@mui/icons-material/Circle";
import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Stack,
  FormLabel,
} from "@mui/material";

// @ts-ignore - im not actually sure how to type this. more research required - 4/29/25
const PclStatusOptions = ({ field }) => {
  return (
    <Stack gap={0.5} marginTop={3}>
      <FormLabel>Product Status</FormLabel>
      <ToggleButtonGroup
        value={field.state.value}
        orientation="vertical"
        size="small"
        fullWidth
        exclusive
        sx={{
          ".MuiToggleButtonGroup-grouped": {
            marginY: "5px",
            borderRadius: "4px",
            "&.Mui-selected": {
              background: "#0b2241",
              color: "white",
              "&:hover": {
                background: "#0b2241",
              },
            },
          },
        }}
        onChange={(_e, status) => {
          field.handleChange(status);
        }}
      >
        <StatusButton
          value="Certified"
          label="Certified"
          color="var(--bs-green)"
        />
        <StatusButton
          value="In Progress"
          label="In Evaluation"
          color="var(--bs-yellow)"
        />
        <StatusButton
          value="Archived"
          label="Archived"
          color="var(--bs-orange)"
        />
      </ToggleButtonGroup>
    </Stack>
  );
};
export default PclStatusOptions;

interface StatusButtonProps {
  color: string;
  label: string;
  value: string;
}

const StatusButton = ({ color, label, value }: StatusButtonProps) => {
  return (
    <ToggleButton value={value} id={`status-btn-${value}`}>
      <CircleIcon fontSize="small" htmlColor={color} />
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography
        fontSize="14px"
        fontFamily="var(--bs-btn-font-family)"
        flex="1"
        marginLeft={-1}
      >
        {label}
      </Typography>
    </ToggleButton>
  );
};
